import React, { useEffect, useMemo } from 'react'
import { useNotificationsSelector } from '../../../store/selectors/notifications'
import { useModalContext } from '../../../context/modalContext'
import styles from './NotificationModal.module.scss'
import ButtonUi from '../../ui/ButtonUi/ButtonUi'
import { readNotification } from '../../../store/notifications/thunks'
import { useAppDispatch } from '../../../store/hooks'
import { IconCheckCircle, IconTimesCircle } from '../../../utils/icons'

interface Props {
  id: string
}

const NotificationModal: React.FC<Props> = ({ id }) => {
  const { msg } = useNotificationsSelector()
  const { setModalComponent } = useModalContext()
  const dispatch = useAppDispatch()
  const message = useMemo(() => msg.find((el) => el.id === id), [id])

  useEffect(() => {
    dispatch(readNotification(id)).then()
  }, [id])

  return (
    <div className={styles.container}>
      {message ? (
        <>
          <div className={styles.title}>{message.title}</div>
          <div className={styles.body}>
            <IconCheckCircle width='35' height='35' fill='var(--color-green)' />
            <p>{message.description}</p>
          </div>
          <div className={styles.actions}>
            <ButtonUi color='red' onClick={() => setModalComponent({ component: null })}>
              <IconTimesCircle width='18' height='18' fill='var(--color-red)' />
              Закрыть
            </ButtonUi>
          </div>
        </>
      ) : (
        <div className={styles.empty}>Сообщение не найдено</div>
      )}
    </div>
  )
}

export default NotificationModal
